module.exports = __webpack_public_path__ + "images/store_case_study/brand-fun-pic1_0cedf268e3cb4e7913dc397c4b7121a1.jpg";